import { serverTimestamp } from "firebase/firestore";
import { utcTimestampToLocal } from "../../utils/dateTimeUtils";

export default class Route {
  constructor(data = {}) {
    this.id = data.id;
    this.encodedPlannedPolyline = data.encodedPlannedPolyline;
    this.points =
      data?.points?.map((point) => ({
        lat: point.lat,
        lng: point.lng,
        timestamp: utcTimestampToLocal(point.timestamp),
        speed: point.speed,
        heading: point.heading,
        driverId: point.driverId,
        stopId: point.stopId,
      })) ?? [];
    this.metadata = {
      createdAt: utcTimestampToLocal(data.metadata?.createdAt),
      updatedAt: utcTimestampToLocal(data.metadata?.updatedAt),
    };
  }

  static toJSON(data) {
    const now = serverTimestamp();

    return {
      id: data.id,
      encodedPlannedPolyline: data.encodedPlannedPolyline || "",
      points: [],
      metadata: {
        createdAt: now,
        updatedAt: now,
      },
    };
  }

  /**
   * This function does not expect to see the `points` field. This is intentional.
   * Only the driver app should edit that field.
   */
  static toJSONUpdate(data) {
    const baseData = { ...data };

    if (!baseData.metadata) {
      baseData.metadata = {};
    }

    delete baseData.metadata.createdAt;
    baseData.metadata.updatedAt = serverTimestamp();
    delete baseData.points;

    return baseData;
  }
}
